// constants/colors.js
export const COLORS = {
  primary: {
    lavender: "#2D8CFF",     // Bleu Doctolib principal
    sky: "#86bae4ff",         // Bleu clair Doctolib
    blush: "#639bc7ff",       // Bleu pastel
    main: "#2463b1ff",        // Bleu Doctolib foncé
    red: "#FF6B6B",
  },
  secondary: {
    mint: "#20C997",        // Vert succès
    peach: "#d36666ff",       // Rouge/rose pour les urgences
    gold: "#b9be6fff",        // Jaune pour les alertes
  },
  neutral: {
    white: "#FFFFFF",
    light: "#F8F9FA",       // Gris très clair
    gray: "#a3a8adff",        // Gris moyen
    dark: "#212529",        // Gris très foncé
    surface: "#e0e5ebff",     // Gris de fond
  },
};

export const GRADIENTS = {
  background: ["#FFFFFF", "#F8F9FA"],   // Blanc pur à gris très clair
  primary: ["#2D8CFF", "#1E7AE8"],      // Dégradé bleu Doctolib
  button: ["#4DABF7", "#2D8CFF"],       // Dégradé button bleu
  card: ["#FFFFFF", "#F8F9FA"],         // Cartes légèrement ombrées
};